import store from '../../store/index';

/**
 * Get the default car alert name
 * @param {string} manufacturer (optional)
 * @param {string} model (optional)
 * @returns
 */
export default function(manufacturer = '', model = '') {
    let searchName = 'Used ';

    if (manufacturer != '') {
        searchName += manufacturer + ' ';
    } else if (store.state.UsedSearchOptions.userOptions.manufacturer != '') {
        searchName += store.state.UsedSearchOptions.userOptions.manufacturer + ' ';
    }

    if (model != '') {
        searchName += model + ' ';
    } else if (store.state.UsedSearchOptions.userOptions.model != '') {
        searchName += store.state.UsedSearchOptions.userOptions.model + ' ';
    }

    if (searchName != 'Used ') {
        return searchName.trim();
    }

    return 'Used Stock Alert';
}